import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { MuiMarkdown_V2 } from "../Shared/components/MuiMarkdown/MuiMarkdown_V2";
export const LocationTitle = ({ deliveryMethodMarkdown }) => (_jsx(Box, Object.assign({ px: 3, py: 0 }, { children: _jsx(MuiMarkdown_V2, { children: deliveryMethodMarkdown }) })));
